var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8334 27.9201C36.8318 32.4657 33.6376 36.2649 29.3714 37.1975L28.3613 34.167C30.2676 33.8559 31.8878 32.6937 32.8194 31.0833H28.9167C27.1677 31.0833 25.75 29.6656 25.75 27.9166V21.5833C25.75 19.8343 27.1677 18.4166 28.9167 18.4166H33.5687C32.7895 12.1683 27.4594 7.33329 21 7.33329C14.5406 7.33329 9.2105 12.1683 8.43135 18.4166H13.0834C14.8323 18.4166 16.25 19.8343 16.25 21.5833V27.9166C16.25 29.6656 14.8323 31.0833 13.0834 31.0833H8.33335C6.58445 31.0833 5.16669 29.6656 5.16669 27.9166V20C5.16669 11.2554 12.2555 4.16663 21 4.16663C29.7445 4.16663 36.8334 11.2554 36.8334 20V21.5812V21.5833V27.9166V27.9201ZM33.6667 27.9166V21.5833H28.9167V27.9166H33.6667ZM8.33335 21.5833V27.9166H13.0834V21.5833H8.33335Z",
    fill: "#0AC79A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.67f61202804710dd6818b330deca1da1.svg";
export { ForwardRef as ReactComponent };